import Vue from "vue"
import Router from "vue-router"
import Tournaments from "@/views/tournaments/Tournaments"
import TournamentsSingle from "@/views/tournaments/TournamentsSingle"
import Error400 from "@/views/errors/400"
import Error404 from "@/views/errors/404"
import Error500 from "@/views/errors/500"

Vue.use(Router)

const RouterView = {
  render: h => h("RouterView")
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: "/",
      name: "Home",
      redirect: "/tournaments"
    },
    {
      path: "/setup",
      name: "Account Setup",
      meta: { breadcrumb: { title: "Account Setup" } },
      component: () => import("./views/AccountSetup")
    },
    {
      path: "/tournaments",
      component: RouterView,
      meta: { breadcrumb: { title: "Tournaments" } },
      children: [
        {
          path: "",
          name: "Tournaments",
          component: Tournaments
        },
        {
          path: "create",
          name: "TournamentsCreate",
          meta: { breadcrumb: { title: "Create" } },
          component: () => import("./views/tournaments/TournamentsCreate")
        },
        {
          path: ":tournamentAddress",
          component: RouterView,
          meta: { breadcrumb: { title: ":tournamentAddress", type: "address" } },
          children: [
            {
              path: "",
              name: "TournamentsSingle",
              props: true,
              component: TournamentsSingle
            },
            {
              path: "round",
              component: RouterView,
              children: [
                {
                  path: "",
                  redirect: { name: "TournamentsSingle" }
                },
                {
                  path: ":roundId",
                  name: "TournamentsSingleRound",
                  props: true,
                  component: TournamentsSingle
                }
              ]
            },
            {
              path: "edit",
              name: "TournamentsEdit",
              props: true,
              meta: { breadcrumb: { title: "Edit" } },
              component: () => import("./views/tournaments/TournamentsEdit")
            },
            {
              path: "submit",
              name: "CreateSubmission",
              props: true,
              meta: { breadcrumb: { title: "Create Submission" } },
              component: () => import("./views/commits/CommitsCreate")
            }
          ]
        }
      ]
    },
    {
      path: "/first-to-hash",
      name: "CommitsCreate",
      meta: { breadcrumb: { title: "First to Hash" } },
      component: () => import("./views/commits/CommitsCreate")
    },
    {
      path: "/commits",
      component: RouterView,
      meta: { breadcrumb: { title: "Commits", noLink: true } },
      children: [
        {
          path: "",
          name: "Commits",
          redirect: { name: "CommitsCreate" }
        },
        {
          path: ":commitHash",
          name: "CommitsSingle",
          props: true,
          meta: { breadcrumb: { title: ":commitHash", type: "address" } },
          component: () => import("./views/commits/CommitsSingle")
        }
      ]
    },
    {
      path: "/submissions",
      component: RouterView,
      meta: { breadcrumb: { title: "Submissions", noLink: true } },
      children: [
        {
          path: "",
          name: "Submissions",
          redirect: { name: "SubmissionsSingle" }
        },
        {
          path: ":submissionHash",
          name: "SubmissionsSingle",
          props: true,
          meta: { breadcrumb: { title: ":submissionHash", type: "address" } },
          component: () => import("./views/submissions/SubmissionsSingle")
        }
      ]
    },
    {
      path: "/account",
      name: "UserAccount",
      meta: { breadcrumb: { title: "Account" } },
      component: () => import("./views/UserAccount.vue")
    },
    {
      path: "/profile",
      component: RouterView,
      meta: { breadcrumb: { title: "Profile", noLink: true } },
      children: [
        {
          path: ":userAddress",
          name: "UserProfile",
          props: true,
          meta: { breadcrumb: { title: ":userAddress", type: "address" } },
          component: () => import("./views/UserProfile")
        }
      ]
    },
    {
      path: "/about",
      name: "About",
      meta: { breadcrumb: { title: "About" } },
      component: () => import("./views/About")
    },
    {
      path: "/faucet",
      name: "Faucet",
      meta: { breadcrumb: { title: "Faucet" } },
      component: () => import("./views/Faucet")
    },
    {
      path: "/token",
      name: "Token",
      meta: { breadcrumb: { title: "Token" } },
      component: () => import("./views/TokenInfo")
    },
    {
      path: "/400",
      name: "Error400",
      props: true,
      component: Error400
    },
    {
      path: "/network-error",
      name: "Error500",
      props: true,
      component: Error500
    },
    {
      path: "*",
      name: "Error404",
      props: true,
      component: Error404
    }
  ]
})

export default router
